import { FsErrorResponse } from '@fairandsmart/angular';
import { EntityCollection, EntityReference, Task } from '@fairandsmart/types';
import { Action } from '@ngrx/store';

export enum TaskActionTypes {

  CloseTaskPanel = '[Task Panel] Close task panel',
  SelectUserTab = '[Task Panel] Select user tasks tab',
  SelectRefTab = '[Task Panel] Select reference tasks tab',
  CreateRefTask = '[Task Panel] Create reference task',
  RefreshTasks = '[Task Panel] Refresh Tasks',

  ShowUserTasks = '[Header] Show user tasks',
  CountUserTasksToDo = '[Header] Count user tasks to do',
  CountUserTasksToDoSuccess = '[Task API] Count user tasks to do success',
  CountUserTasksToDoFailure = '[Task API] Count user tasks to do failure',

  ShowRequestTasks = '[Request page] Show request tasks',
  CreateRequestTask = '[Request page] Create task for request',

  LoadUserTasks = '[Task Panel] Load user tasks',
  LoadUserTasksSuccess = '[Task API] Load user tasks success',
  LoadUserTasksFailure = '[Task API] Load user tasks failure',

  LoadRefTasks = '[Entity page] Load reference tasks',
  LoadRefTasksSuccess = '[Task API] Load reference tasks success',
  LoadRefTasksFailure = '[Task API] Load reference tasks failure',

  QuitEntityPage = '[Entity page] Quit entity page',

  ShowTaskDetail = '[Task Card] Show task detail',

  AssignTask = '[Task Card] Assign task',
  AssignTaskSuccess = '[Task API] Assign task success',

  CancelTask = '[Task Card] Cancel task',
  CancelTaskSuccess = '[Task API] Cancel task success',

  CompleteTask = '[Task Card] Complete task',
  CompleteTaskSuccess = '[Task API] Complete task success',

  CreateTaskSuccess = '[Task API] Create task success',
  UpdateTaskSuccess = '[Task API] Update task success',
  AddCommentSuccess = '[Task API] Add comment to task success',
}

export class CloseTaskPanel implements Action {
  readonly type = TaskActionTypes.CloseTaskPanel;
}

export class SelectUserTab implements Action {
  readonly type = TaskActionTypes.SelectUserTab;
}

export class SelectRefTab implements Action {
  readonly type = TaskActionTypes.SelectRefTab;
}

export class LoadUserTasks implements Action {
  readonly type = TaskActionTypes.LoadUserTasks;
}

export class LoadUserTasksSuccess implements Action {
  readonly type = TaskActionTypes.LoadUserTasksSuccess;

  constructor(public payload: { response: EntityCollection<Task> }) {}
}

export class ShowUserTasks implements Action {
  readonly type = TaskActionTypes.ShowUserTasks;
}

export class LoadUserTasksFailure implements Action {
  readonly type = TaskActionTypes.LoadUserTasksFailure;

  constructor(public payload: { response: FsErrorResponse }) {}
}

export class CountUserTasksToDo implements Action {
  readonly type = TaskActionTypes.CountUserTasksToDo;
}

export class CountUserTasksToDoSuccess implements Action {
  readonly type = TaskActionTypes.CountUserTasksToDoSuccess;

  constructor(public payload: { count: number }) {}
}

export class CountUserTasksToDoFailure implements Action {
  readonly type = TaskActionTypes.CountUserTasksToDoFailure;

  constructor(public payload: { response: FsErrorResponse }) {}
}

export class ShowRequestTasks implements Action {
  readonly type = TaskActionTypes.ShowRequestTasks;
}

export class LoadRefTasks implements Action {
  readonly type = TaskActionTypes.LoadRefTasks;

  constructor(public payload: { reference: EntityReference }) {}
}

export class LoadRefTasksSuccess implements Action {
  readonly type = TaskActionTypes.LoadRefTasksSuccess;

  constructor(public payload: { response: EntityCollection<Task>, refIdentifier: EntityReference }) {}
}

export class LoadRefTasksFailure implements Action {
  readonly type = TaskActionTypes.LoadRefTasksFailure;

  constructor(public payload: { response: FsErrorResponse }) {}
}

export class QuitEntityPage implements Action {
  readonly type = TaskActionTypes.QuitEntityPage;
}

export class ShowTaskDetail implements Action {
  readonly type = TaskActionTypes.ShowTaskDetail;

  constructor(public payload: { task: Task }) {}
}

export class AssignTask implements Action {
  readonly type = TaskActionTypes.AssignTask;

  constructor(public payload: { taskId: string, assignee: string, previousAssignee: string }) {}
}

export class AssignTaskSuccess implements Action {
  readonly type = TaskActionTypes.AssignTaskSuccess;

  constructor(public payload: { task: Task, previousAssignee: string }) {}
}

export class CancelTask implements Action {
  readonly type = TaskActionTypes.CancelTask;

  constructor(public payload: { task: Task, variables?: { [key: string]: string } }) {}
}

export class CancelTaskSuccess implements Action {
  readonly type = TaskActionTypes.CancelTaskSuccess;

  constructor(public payload: { task: Task }) {}
}

export class CompleteTask implements Action {
  readonly type = TaskActionTypes.CompleteTask;

  constructor(public payload: { task: Task, variables?: { [key: string]: string } }) {}
}

export class CompleteTaskSuccess implements Action {
  readonly type = TaskActionTypes.CompleteTaskSuccess;

  constructor(public payload: { task: Task }) {}
}

export class RefreshTasks implements Action {
  readonly type = TaskActionTypes.RefreshTasks;
}

export class CreateRefTask implements Action {
  readonly type = TaskActionTypes.CreateRefTask;

  constructor(public payload: { reference: EntityReference }) {}
}

export class CreateRequestTask implements Action {
  readonly type = TaskActionTypes.CreateRequestTask;

  constructor(public payload: { reference: EntityReference }) {}
}

export class CreateTaskSuccess implements Action {
  readonly type = TaskActionTypes.CreateTaskSuccess;

  constructor(public payload: { task: Task }) {}
}

export class UpdateTaskSuccess implements Action {
  readonly type = TaskActionTypes.UpdateTaskSuccess;

  constructor(public payload: { task: Task }) {}
}

export class AddCommentSuccess implements Action {
  readonly type = TaskActionTypes.AddCommentSuccess;

  constructor(public payload: { task: Task }) {}
}

export type TaskActions =
  CloseTaskPanel
  | SelectUserTab
  | SelectRefTab
  | ShowUserTasks
  | LoadUserTasks
  | LoadUserTasksSuccess
  | LoadUserTasksFailure
  | ShowRequestTasks
  | LoadRefTasks
  | LoadRefTasksSuccess
  | LoadRefTasksFailure
  | QuitEntityPage
  | CountUserTasksToDo
  | CountUserTasksToDoSuccess
  | CountUserTasksToDoFailure
  | AssignTask
  | AssignTaskSuccess
  | CompleteTask
  | CompleteTaskSuccess
  | CancelTask
  | CreateRefTask
  | CreateRequestTask
  | CreateTaskSuccess
  | UpdateTaskSuccess
  | AddCommentSuccess
  | RefreshTasks;
